import { Box, Button, Chip } from "@mui/joy";
import { CheckIcon, CloseIcon } from "../../../../styles/StyledMUI";
import { colorTokens, hrAccentColor, withAlpha } from "styles/globalStyles";

export const PLANNING_LEAVE_EMOJI = "\u{1F3D6}\u{FE0F}";
export const PLANNING_BOOKING_EMOJI = "\u{1F4BC}";
export const PLANNING_UNAVAILABLE_EMOJI = "\u{274C}";
export const PLANNING_LEAVE_CHIP_BG = withAlpha("#42a5f5", 0.35);
export const PLANNING_BOOKING_CHIP_BG = withAlpha(colorTokens.status.warning, 0.35);

const planningDayChipSx = {
  backgroundColor: colorTokens.bg.surfaceMuted,
  color: colorTokens.text.primary,
  fontSize: { xs: "0.68rem", sm: "0.72rem" },
  fontWeight: 600,
  height: "auto",
  minHeight: 20,
  py: 0.1,
  maxWidth: "100%",
  "& .MuiChip-label": {
    px: 0.4,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  "& .MuiChip-startDecorator": {
    ml: 0.3,
    mr: 0,
  },
} as const;

const planningDayChipBadgeSx = {
  ml: 0.3,
  px: 0.4,
  borderRadius: "8px",
  fontSize: "0.6rem",
  fontWeight: 700,
  lineHeight: "14px",
  minWidth: "14px",
  textAlign: "center",
  backgroundColor: withAlpha("#ffffff", 0.3),
  color: colorTokens.text.primary,
} as const;

export function PlanningDayChip({
  emoji,
  label,
  bgColor,
  badge,
}: {
  emoji: string;
  label: string;
  bgColor?: string;
  badge?: number;
}) {
  return (
    <Chip
      size="sm"
      variant="soft"
      sx={bgColor ? { ...planningDayChipSx, backgroundColor: bgColor } : planningDayChipSx}
      startDecorator={
        <Box component="span" sx={{ fontSize: "0.8rem", lineHeight: 1 }}>
          {emoji}
        </Box>
      }
      endDecorator={
        badge != null && badge > 1 ? (
          <Box component="span" sx={planningDayChipBadgeSx}>
            {badge}
          </Box>
        ) : undefined
      }
    >
      {label}
    </Chip>
  );
}

export function BookingValidationFooter({
  onValidate,
  onReject,
}: {
  onValidate: () => void;
  onReject: () => void;
}) {
  return (
    <Box
      sx={{ pt: 1, mt: 1, borderTop: `1px solid ${hrAccentColor}`, minWidth: 0 }}
      onClick={(e) => e.stopPropagation()}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 1,
          width: "100%",
          justifyContent: "stretch",
        }}
      >
        <Button
          type="button"
          variant="solid"
          color="success"
          size="md"
          aria-label="Valider la prestation"
          onClick={onValidate}
          sx={{
            flex: 1,
            minHeight: 44,
            minWidth: 44,
            fontWeight: 700,
            boxShadow: `0 2px 10px ${withAlpha(colorTokens.status.success, 0.45)}`,
            px: 0,
          }}
        >
          <CheckIcon sx={{ fontSize: 22 }} />
        </Button>
        <Button
          type="button"
          variant="solid"
          color="danger"
          size="md"
          aria-label="Refuser la prestation"
          onClick={onReject}
          sx={{
            flex: 1,
            minHeight: 44,
            minWidth: 44,
            fontWeight: 700,
            boxShadow: `0 2px 10px ${withAlpha(colorTokens.status.danger, 0.4)}`,
            px: 0,
          }}
        >
          <CloseIcon sx={{ fontSize: 22 }} />
        </Button>
      </Box>
    </Box>
  );
}
